/**
 * sl-y2po.11: FeatureGateProvider
 *
 * Provider component that:
 * 1. Fetches workspace feature availability on mount
 * 2. Provides FeatureGateContext to the component tree
 * 3. Toggles body classes for Lit<->React bridge
 *
 * Mount at workspace scope, wrapping WorkflowGateProvider and ElsterGateProvider
 * so that connectivity gates can read plan-based availability.
 *
 * SOLID:
 * - S: Only plan-based feature context provision
 */
import { type ReactNode } from 'react';

import {
  FeatureGateContext,
  useFeatureGateFetch,
} from '../hooks/use-feature-gate';

interface FeatureGateProviderProps {
  children: ReactNode;
}

/**
 * Provider that manages plan-based feature availability.
 * Fetches from GET /api/workspace/:id/features and provides context.
 */
export function FeatureGateProvider({ children }: FeatureGateProviderProps) {
  const value = useFeatureGateFetch();

  return (
    <FeatureGateContext.Provider value={value}>
      {children}
    </FeatureGateContext.Provider>
  );
}
